import React from 'react'
import styled from 'styled-components'
import { skills } from '../../data/constants'

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1100px;
gap: 12px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

export const Title = styled.div`
  font-size: 48px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 60%, #854CE6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 16px;
  border-radius: 12px;
  
  &:hover {
    background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 40%, #FF6B6B 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transform: translateY(-2px);
    
    &::after {
      background: linear-gradient(90deg, #FF6B6B, #ff8a8a);
      width: 80px;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #854CE6, #FF6B6B);
    border-radius: 2px;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

export const Desc = styled.div`
    font-size: 20px;
    text-align: center;
    max-width: 700px;
    color: ${({ theme }) => theme.text_primary};
    opacity: 0.8;
    line-height: 1.6;
    margin-bottom: 8px;
    font-weight: 400;
    
    @media (max-width: 768px) {
        font-size: 18px;
        max-width: 500px;
    }
`;

const SkillsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  gap: 30px;
  justify-content: center;
`

const Skill = styled.div`
  width: 100%;
  max-width: 500px;
  background: linear-gradient(135deg, ${({ theme }) => theme.card} 0%, ${({ theme }) => theme.card_light} 100%);
  border: 1px solid rgba(133, 76, 230, 0.2);
  box-shadow: 0 8px 32px rgba(133, 76, 230, 0.12);
  border-radius: 20px;
  padding: 24px 32px;
  transition: all 0.3s ease;
  will-change: transform, box-shadow;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #FF6B6B, #ff8a8a, #ffb3b3);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    box-shadow: 0 16px 48px rgba(133, 76, 230, 0.25);
    transform: translateY(-6px);
    border-color: rgba(133, 76, 230, 0.4);
    
    &::before {
      opacity: 1;
    }
  }
  
  @media (max-width: 768px) {
    max-width: 400px;
    padding: 20px 24px;
  }
  @media (max-width: 500px) {
    max-width: 330px;
    padding: 18px 20px;
  }
`;

const SkillTitle = styled.h2`
  font-size: 26px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 24px;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 120px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #FF6B6B, transparent);
    opacity: 0.6;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;

const SkillList = styled.div`
  display: flex;
  justify-content: center; 
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
`

const SkillItem = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary};
  background: rgba(133, 76, 230, 0.08);
  border: 1px solid rgba(133, 76, 230, 0.2);
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 107, 107, 0.15);
    border-color: rgba(255, 107, 107, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(255, 107, 107, 0.2);
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 14px;
    gap: 8px;
  }
  @media (max-width: 500px) {
    font-size: 13px;
    padding: 8px 12px;
    gap: 6px;
  }
`;

const SkillImage = styled.img`
  width: 24px;
  height: 24px;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
  
  @media (max-width: 500px) {
    width: 18px;
    height: 18px;
  }
`;


const Skills = () => {
  return (
    <Container id="skills">
      <Wrapper>
        <Title>Skills</Title>
        <Desc>Here are some of my skills on which I have been working on for the past 5+ years.
        </Desc>
        <SkillsContainer>
          {skills.map((skill) => (
            <Skill>
              <SkillTitle>{skill.title}</SkillTitle>
              <SkillList>
                {skill.skills.map((item) => (
                  <SkillItem>
                    <SkillImage src={item.image} />
                    {item.name}
                  </SkillItem>
                ))}
              </SkillList>
            </Skill>
          ))}

        </SkillsContainer>
      </Wrapper>
    </Container>
  )
}

export default Skills